import React, { useEffect, useState } from 'react';
import { getInspectTopElements } from '../utils/routeDebug';

export default function RouteDebugOverlay() {
  const [data, setData] = useState({ points: [], blockers: [] });
  const [highlight, setHighlight] = useState(false);

  useEffect(() => {
    function refresh() {
      try {
        const res = getInspectTopElements();
        setData({ points: res.points || [], blockers: res.blockers || [] });
      } catch (e) { console.warn('[RouteDebugOverlay] refresh failed', e); }
    }

    refresh();
    const id = setInterval(refresh, 2000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (!highlight) {
      // remove outlines
      data.blockers.forEach(b => { try { b.node && (b.node.style.outline = ''); } catch (err) { void err; } });
      data.points.forEach(p => { try { p.node && (p.node.style.outline = ''); } catch (err) { void err; } });
      return;
    }

    // apply outlines
    data.blockers.forEach(b => { try { if (b.node) b.node.style.outline = '3px solid rgba(255,0,0,0.8)'; } catch (err) { void err; } });
    data.points.forEach((p) => { try { if (p.node) p.node.style.outline = `2px dashed rgba(0,128,255,0.9)`; } catch (err) { void err; } });

    return () => {
      // cleanup
      data.blockers.forEach(b => { try { b.node && (b.node.style.outline = ''); } catch (err) { void err; } });
      data.points.forEach(p => { try { p.node && (p.node.style.outline = ''); } catch (err) { void err; } });
    };
  }, [highlight, data]);

  const mounted = (typeof window !== 'undefined' && window.__routeDebugMounted) ? window.__routeDebugMounted.slice() : [];

  return (
    <div style={{position: 'fixed', right: 12, bottom: 12, zIndex: 99999, width: 360, maxHeight: '60vh', overflow: 'auto', background: 'rgba(0,0,0,0.75)', color: 'white', padding: 'var(--space-12)', borderRadius: 8, fontSize: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.6)'}}>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-8)'}}>
        <strong>Route Debug Overlay</strong>
        <div>
          <button onClick={() => { setHighlight(h => !h); }} style={{marginRight:'var(--space-8)'}}>Highlight</button>
          <button onClick={() => { try { localStorage.removeItem('routeDebugOverlay'); window.location.reload(); } catch (err) { window.location.reload(); void err; } }}>Close</button>
        </div>
      </div>

      <div style={{marginBottom:'var(--space-8)'}}><strong>Mounted pages:</strong> {mounted.length ? mounted.join(', ') : <em>none</em>}</div>

      <div style={{marginBottom:'var(--space-8)'}}>
        <strong>Points inspection:</strong>
        {data.points.map((p, i) => (
          <div key={i} style={{marginTop:6, paddingTop:6, borderTop: '1px solid rgba(255,255,255,0.06)'}}>
            <div><strong>Point {i+1}</strong> ({p.point.x}, {p.point.y})</div>
            <div>Tag: {p.tag || '—'} | id: {p.id || '—'} | class: {p.class || '—'}</div>
            <div>Rect: {p.rect ? `${Math.round(p.rect.x)}x${Math.round(p.rect.y)} ${Math.round(p.rect.w)}×${Math.round(p.rect.h)}` : '—'}</div>
            <div>PointerEvents: {p.pointerEvents} | zIndex: {p.zIndex}</div>
          </div>
        ))}
      </div>

      <div>
        <strong>Potential blocking elements:</strong>
        {data.blockers.length ? data.blockers.map((b, i) => (
          <div key={i} style={{marginTop:6, paddingTop:6, borderTop: '1px solid rgba(255,255,255,0.06)'}}>
            <div><strong>{b.tag}</strong> id:{b.id || '—'} class:{b.class || '—'}</div>
            <div>Rect: {Math.round(b.rect.x)}x{Math.round(b.rect.y)} {Math.round(b.rect.width)}×{Math.round(b.rect.height)}</div>
            <div>zIndex: {b.zIndex}</div>
          </div>
        )) : <div style={{marginTop:6}}>No obvious blockers detected.</div>}
      </div>
    </div>
  );
}
